import {formActions} from '@/enums/formActions'
import {mapFilters} from "@/utils/helpers";
import {propertyNames} from "@/enums/propertyNames";

const initState = () => ({
  customerBalances: [],
})

export const state = initState

export const getters = {
}

export const mutations = {
  setCustomerBalances(state, {reports}){
    state.customerBalances = reports
  },
  addCustomerBalances(state,{reports}){
    reports.forEach(r => state.customerBalances.items.push(r))
  },
  resetCustomerBalances(state){
    state.customerBalances.items = []
    state.customerBalances.itemCount = 0
  },
}

export const actions = {
  async getCustomerBalances({commit, dispatch}, {filters, options}){
    return new Promise((resolve, reject) => {
      this.$catch(
        async () => {
          let url = `/webpos/reports/customerBalances`
          let filter = {}
          filters.map((f) => {
            if (f.value) {
              if(Array.isArray(f.value)){
                Object.assign(filter, {[f.property]: f.value.toString()})
              }
              else{
                Object.assign(filter, {[f.property]: f.value})
              }
            }
          })
          Object.assign(filter, {pageNo: options.page - 1})
          Object.assign(filter, {pageSize: options.itemsPerPage})
          Object.assign(filter, {sortBy: options.sortBy[0] || null})
          Object.assign(filter, {sortAsc: !options.sortDesc[0]})


          let reports = await this.$axios.$post(url,filter)
          reports = await dispatch('mapCustomerBalances', {response: reports})
          commit('setCustomerBalances', {reports: reports})
          resolve(reports)
        },
        formActions.Load,
        'reports'
      )
    })
  },

  async getSaleReports({commit, dispatch}, {filters, pagingInfo})  {
    let saleReportItems = []
    try{
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let result = await this.$axios.post(`/webpos/reports/sale-reports`, filter);
      if (result && !result.data.hasErrors) {
        saleReportItems = result.data;
      }
      else {
        this.$toast.error("Error while getting sale reports");
      }
    }
    catch{
      this.$toast.error("Error while getting sale reports");
    }
    return saleReportItems;
  },

  async getSaleReportsTotal({}, {filters, pagingInfo})  {
    let getSaleReportsTotal = {}

    try{
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let result = await this.$axios.post('/webpos/reports/sale-reports-totals', filter);
      if (result && !result.data.hasErrors) {
        getSaleReportsTotal = result.data.value;
      }
      else {
        this.$toast.error("Error while getting sale reports total");
      }
    }
    catch{
      this.$toast.error("Error while getting sale reports total");
    }
    return getSaleReportsTotal;
  },


  async getSalesByItemsReports({commit, dispatch}, {filters, pagingInfo})  {

    let result = [];
    try{

      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let url = `webpos/reports/sales-by-items-reports?${new URLSearchParams(filter).toString()}`

      const response = await this.$axios.get(url)
      if (!response || response.data.hasErrors) {
        this.$toast.error("Error while getting catalog order sales report")
      }
      else{
        result = response.data;
      }
    }catch(e){

      this.$toast.error("Error while getting catalog order sales report")
    }

    return result

  },


  async getSoldItemsByProductCatalog({commit},{productCatalogID, filters}){
    let result = []
    try{
      let filter = mapFilters(filters, 0,0,'',false);
      let url = `webpos/product-catalog/${productCatalogID}/sold-item-types?${new URLSearchParams(filter).toString()}`
      const response = await this.$axios.$get(url);
      if(result.hasErrors || result.errorMessage){
        this.$toast.error("Error while getting items for the product catalog");
      }
      else{
        result = response.value
      }
    }
    catch(e){
      this.$toast.error("Error while getting items for the product catalog");
    }
    return result
  },

  async getSalesHistoryReport({commit, dispatch}, {filters, pagingInfo, refreshTotals = true})  {
    try{
      let url = `/webpos/reports/sales-history?refreshTotals=${refreshTotals}`
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);

      let reports = await this.$axios.$post(url,filter)
      if (reports.hasErrors){
        this.$toast.error("Error while getting sales history!");
        return { salesHistory: []}
      }
      else
      {
        return reports.value;
      }
    }
    catch (e) {
      this.$toast.error("Error while getting sales history!");
      return {salesHistory: []}
    }

  },

  async fetchCustomerEvents({commit, dispatch}, {filters, pagingInfo}) {
    let events = []
    try{
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let result = await this.$axios.post(`webpos/reports/customer-events`, filter);
      if (result && !result.data.hasErrors) {
        events = result.data;
      }
      else {
        this.$toast.error("Error while getting customer events");
      }
    }
    catch{
      this.$toast.error("Error while getting customer events");
    }
    return events;
  },

  async fetchCustomerSaleDetail({commit, dispatch}, {customerID , filters}){
    let result = [];
    try{

      let filter = mapFilters(filters, 0,0, '', false);
      let url = `webpos/reports/customer/${customerID}/sale-detail?${new URLSearchParams(filter).toString()}`

      const response = await this.$axios.get(url)
      if (!response || response.data.hasErrors) {
        this.$toast.error("Error while getting sales data for customer")
      }
      else{
        result = response.data.value;
      }
    }
    catch(e){
      console.error(e)
      this.$toast.error("Error while getting sales data for customer")
    }
    return result
  },

  async fetchWishlistItems({commit, dispatch}, {filters, pagingInfo}) {
    let wishlistItems = []
    try{
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let result = await this.$axios.post(`webpos/reports/wishlist-items`, filter);
      if (result && !result.data.hasErrors) {
        wishlistItems = result.data;
      }
      else {
        this.$toast.error("Error while getting wishlist items");
      }
    }
    catch{
      this.$toast.error("Error while getting wishlist items");
    }
    return wishlistItems;
  },

  async fetchLayawayListItems({commit, dispatch}, {filters, pagingInfo}){
    let layawaysListItems = []
    try{
      let filter = mapFilters(filters,pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let result = await this.$axios.post(`webpos/reports/layaway-items`, filter);
      if (result && !result.data.hasErrors) {
        layawaysListItems = result.data;
      }
      else {
        this.$toast.error("Error while getting layaway items");
      }

    }
    catch{
      this.$toast.error("Error while getting layaway items");
    }
    return layawaysListItems;
  },

  async mapCustomerBalances({commit},{response}){
    let reportResponse = response.data ? response.data : response
    let reports = {
      items: [],
      itemCount: null
    }
    reportResponse.items.map(x => {
     let customerBalance =  {
        id: x.id,
        customerName: x.customerName,
        emailAddress: x.emailAddress,
        phoneNumber: x.phoneNumber,
        paid: x.paid,
        balance: x.balance,
        totalValue: x.totalValue
      }
      reports.items.push(customerBalance)
    })
    reports.itemCount = reportResponse.pagingData.itemCount
    return reports
  },

  async getSoldCustomOrderItems({commit, dispatch}, {filters, pagingInfo})  {

    let result = [];
    try{

      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let url = `webpos/custom-order/accepted-item-groups/sold-item-types?${new URLSearchParams(filter).toString()}`

      const response = await this.$axios.get(url)
      if (!response || response.data.hasErrors) {
        this.$toast.error("Error while getting custom order sales report")
      }
      else{
        result = response.data;
      }
    }catch(e){

      this.$toast.error("Error while getting custom order sales report")
    }

    return result

  },

  async getSoldItemsByItemGroup({commit},{itemGroupID, filters}){
    let result = []
    try{
      let filter = mapFilters(filters, 0,0,'',false);
      let url = `webpos/item-group/${itemGroupID}/sold-item-types?${new URLSearchParams(filter).toString()}`
      const response = await this.$axios.$get(url);
      if(result.hasErrors || result.errorMessage){
        this.$toast.error("Error while getting items for the item-group");
      }
      else{
        result = response.value
      }
    }
    catch(e){
      this.$toast.error("Error while getting items for the item-group");
    }
    return result
  },

}
